/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateExerciseDTO,
  ExerciseDTO,
  UpdateExerciseDTO,
} from '../models/index';
import {
    CreateExerciseDTOFromJSON,
    CreateExerciseDTOToJSON,
    ExerciseDTOFromJSON,
    ExerciseDTOToJSON,
    UpdateExerciseDTOFromJSON,
    UpdateExerciseDTOToJSON,
} from '../models/index';

export interface ExerciseCreateRequest {
    createExerciseDTO: CreateExerciseDTO;
}

export interface ExerciseDeleteRequest {
    exerciseId: string;
}

export interface ExerciseExerciseByIdRequest {
    exerciseId: string;
}

export interface ExerciseListByDeckIdRequest {
    deckId: string;
}

export interface ExerciseListByUserIdRequest {
    userId: string;
}

export interface ExerciseUpdateRequest {
    updateExerciseDTO: UpdateExerciseDTO;
}

/**
 * 
 */
export class ExerciseApi extends runtime.BaseAPI {

    /**
     */
    async exerciseCreateRaw(requestParameters: ExerciseCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseDTO>> {
        if (requestParameters['createExerciseDTO'] == null) {
            throw new runtime.RequiredError(
                'createExerciseDTO',
                'Required parameter "createExerciseDTO" was null or undefined when calling exerciseCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/exercise`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExerciseDTOToJSON(requestParameters['createExerciseDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseDTOFromJSON(jsonValue));
    }

    /**
     */
    async exerciseCreate(requestParameters: ExerciseCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseDTO> {
        const response = await this.exerciseCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseDeleteRaw(requestParameters: ExerciseDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['exerciseId'] == null) {
            throw new runtime.RequiredError(
                'exerciseId',
                'Required parameter "exerciseId" was null or undefined when calling exerciseDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise/{exerciseId}`.replace(`{${"exerciseId"}}`, encodeURIComponent(String(requestParameters['exerciseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exerciseDelete(requestParameters: ExerciseDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exerciseDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exerciseExerciseByIdRaw(requestParameters: ExerciseExerciseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseDTO>> {
        if (requestParameters['exerciseId'] == null) {
            throw new runtime.RequiredError(
                'exerciseId',
                'Required parameter "exerciseId" was null or undefined when calling exerciseExerciseById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise/{exerciseId}`.replace(`{${"exerciseId"}}`, encodeURIComponent(String(requestParameters['exerciseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseDTOFromJSON(jsonValue));
    }

    /**
     */
    async exerciseExerciseById(requestParameters: ExerciseExerciseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseDTO> {
        const response = await this.exerciseExerciseByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExerciseDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExerciseDTOFromJSON));
    }

    /**
     */
    async exerciseList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExerciseDTO>> {
        const response = await this.exerciseListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseListByDeckIdRaw(requestParameters: ExerciseListByDeckIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExerciseDTO>>> {
        if (requestParameters['deckId'] == null) {
            throw new runtime.RequiredError(
                'deckId',
                'Required parameter "deckId" was null or undefined when calling exerciseListByDeckId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise/deck/{deckId}`.replace(`{${"deckId"}}`, encodeURIComponent(String(requestParameters['deckId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExerciseDTOFromJSON));
    }

    /**
     */
    async exerciseListByDeckId(requestParameters: ExerciseListByDeckIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExerciseDTO>> {
        const response = await this.exerciseListByDeckIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseListByUserIdRaw(requestParameters: ExerciseListByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExerciseDTO>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling exerciseListByUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExerciseDTOFromJSON));
    }

    /**
     */
    async exerciseListByUserId(requestParameters: ExerciseListByUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExerciseDTO>> {
        const response = await this.exerciseListByUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseUpdateRaw(requestParameters: ExerciseUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseDTO>> {
        if (requestParameters['updateExerciseDTO'] == null) {
            throw new runtime.RequiredError(
                'updateExerciseDTO',
                'Required parameter "updateExerciseDTO" was null or undefined when calling exerciseUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/exercise`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateExerciseDTOToJSON(requestParameters['updateExerciseDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseDTOFromJSON(jsonValue));
    }

    /**
     */
    async exerciseUpdate(requestParameters: ExerciseUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseDTO> {
        const response = await this.exerciseUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
